export default function initPageLink() {
  pageLink();

  function pageLink() {
    // 1. 追加したIDで親要素（section）をピンポイント取得
    const linkContainer = document.getElementById("js-page-link");

    if (!linkContainer) return;

    // sectionの中にある、実際の挿入先（inner）を取得
    const innerContainer = linkContainer.querySelector(".l-page-link__inner");

    // innerがない場合はエラーを防ぐために処理を終了
    if (!innerContainer) return;

    // 2. id が "anchor-" から始まるすべての h2 要素を取得
    const headings = document.querySelectorAll('h2[id^="anchor-"]');

    // もし該当するh2が1つもなければ、セクションごと非表示にして終了する
    if (headings.length === 0) {
      linkContainer.style.display = "none";
      return;
    }

    // 3. 見つかった h2 要素をループ処理してボタンを生成
    headings.forEach((h2) => {
      let contentHtml = h2.innerHTML.trim();
      const id = h2.getAttribute("id");

      const subtxt = h2.getAttribute("data-subtxt");

      // data-subtxtが存在する場合、取得した内容の先頭にくっつける
      if (subtxt) {
        contentHtml = subtxt + " " + contentHtml;
      }

      // 追加するHTMLのブロックを作成（hrefに取得したidをセット）
      const btnHTML = `
      <div class="l-page-link-btn">
        <a href="#${id}" class="l-page-link-btn__link">
          ${contentHtml}
        </a>
      </div>
    `;

      // innerContainer の最後に追加
      innerContainer.insertAdjacentHTML("beforeend", btnHTML);
    });
  }
}
